export const topics = [
  {
    id: "network",
    name: "网络热议",
    icon: "ri-chat-smile-2-line",
    desc: "全网都在聊什么，话题从哪来、往哪去，一次讲清楚。",
    count: 48,
  },
  {
    id: "entertainment",
    name: "娱乐风向",
    icon: "ri-movie-2-line",
    desc: "内容行业的台前幕后，看的是现象，聊的是门道。",
    count: 36,
  },
  {
    id: "society",
    name: "社会百态",
    icon: "ri-earth-line",
    desc: "身边正在发生的事，理性围观，善意讨论。",
    count: 27,
  },
  {
    id: "tech",
    name: "科技新鲜事",
    icon: "ri-cpu-line",
    desc: "新功能、新玩法、新争议，科技圈的热闹也值得一看。",
    count: 21,
  },
  {
    id: "life",
    name: "生活趣闻",
    icon: "ri-emotion-happy-line",
    desc: "轻松一点的内容，聊聊生活里那些让人会心一笑的瞬间。",
    count: 33,
  },
  {
    id: "sports",
    name: "体育快讯",
    icon: "ri-basketball-line",
    desc: "赛场内外的高光与话题，热血之外也有故事。",
    count: 18,
  },
];